<template>
  <div>
    <v-btn class=" blue white--text" text outlined @click="newSaleDialog = true">
      <v-icon>add</v-icon>
      New Order
    </v-btn>
    <v-dialog v-model="newSaleDialog"
                        ref="dialog"
                        width="290px"
              >
                <v-card>
                  <v-card-title>
                    <div class="white black--text text-xs-center font-weight-thin display-1">New Order</div>
                  </v-card-title>
                  <v-card-subtitle class="mt-2 headline" v-if="itemFound">{{itemFound.title}} - ${{itemFound.unitPrice}}</v-card-subtitle>
                  <v-card-text v-if="!loading">

                    <find-item @ItemFound="itemSelected"></find-item>
<!--                    <find-item :listingId="" @ItemFound="itemSelected"></find-item>-->
<!--                    <v-btn block @click="loadListingBaskets" class="blue&#45;&#45;text" dark outlined>create from listing</v-btn>-->
                  </v-card-text>
                  <app-loading v-else></app-loading>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="newSaleDialog = false" text>cancel</v-btn>
                    <v-btn :disabled="!itemFound" @click="createOrder" class="blue white--text">Create Order</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
    <v-dialog v-model="listingBasketsDialog"
              ref="dialog"
              width="350px"
    >
      <v-card>
        <v-card-title>
          <div class="white black--text text-xs-center font-weight-thin display-1">List of baskets</div>
        </v-card-title>
        <v-card-text v-if="loading">
          <app-loading></app-loading>
        </v-card-text>
        <v-card-text v-else>
          <div v-if="baskets.length === 0" class="headline">No baskets found.</div>
          <div v-else>

            <v-expansion-panels>
              <v-expansion-panel v-for="basket in baskets" :key="basket.basketId">
                <v-expansion-panel-header>
                  Id: {{basket.basketId}}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-if="basket.basketItems">
                    <v-list v-if="basket.basketItems.length !== 0">
                      <v-list-item v-for="item in basket.basketItems" :key="item.created">
                        <v-list-item-content>{{item.title}}</v-list-item-content>
                        <v-list-item-action><v-btn @click="createBasketOrder(basket)" class="blue" dark>Create order</v-btn></v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </div>
                  <div v-else>No Items in basket</div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-card-text>
      </v-card>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="listingBasketsDialog = false" text>cancel</v-btn>
      </v-card-actions>
    </v-dialog>
  </div>
</template>

<script>
import {collection, doc, getDocs, limit, where, query, setDoc} from "firebase/firestore";
  import moment from 'moment'
  import { v1 as uuidv1 } from 'uuid';
  export default {
    data () {
      return {
        sales: undefined,
        newSaleDialog: false,
        itemFound: undefined,
        listingBasketsDialog: false,
        baskets: [],
        basketLoadingStatus: 'Loading customer baskets..'
      }
    },
    computed: {
      moment () {
        return (date) => {
          let day = moment(date).format('ddd, MMM Do, hh:mm:ss A')
          return day
        }
      },
      error () {
        return this.$store.getters.error
      },
      loading () {
        return this.$store.getters.loading
      },
      user () {
        return this.$store.getters.user
      },
    },
    methods: {
      createBasketOrder (basket) {
        //console.log(basket)
        this.newSaleDialog = false
        this.listingBasketsDialog = false
        let order = {
          lineItems: basket.basketItems,
          locations: [],
          created: Date.now(),
          total: 0,
          id: uuidv1(),
          fulfillmentInfo: {},
          payments: []
        }
        if(basket.deliveryLocations) {
          order.locations = basket.deliveryLocations
        }
        if (basket.time) {
          order.fulfillmentInfo.time = basket.time
        }
        if (basket.date) {
          order.fulfillmentInfo.date = basket.date
        }
        //console.log(order)
        let db = this.$store.state.db
        let salesRef = doc(db, 'users', this.user.uid, 'orders', order.id)
        let dispatchRef = doc(db, 'users', this.user.uid, 'dispatch', order.id)
        let fulfillmentRef = doc(db, 'users', this.user.uid, 'fulfillment', order.id)
        setDoc(salesRef, order)
            .then(() => {
              return setDoc(dispatchRef, {
                orderData: order,
                contractors: [],
                status: 'warning'
              })
            })
            .then(() => {
              return setDoc(fulfillmentRef, {
                orderData: order,
                ETA: "",
                lastActive: {},
                status: 'warning'
              })
            })
            .then(() => {
              //console.log(order)
              this.$router.push('/booking/' + order.id)
              this.newSaleDialog = false
            })

            .catch(err => [
              this.$store.dispatch('setError', err)
            ])
        //this.$router.push('/booking/' + order.id)
      },
      loadListingBaskets () {
        this.basketLoadingStatus = 'Loading customer baskets..'
        this.listingBasketsDialog = true
        let listingId = this.user.publicListingId
        let db = this.$store.state.db
        let salesRef = collection(db, 'anonUsers')
        let q = query(salesRef, where('listingId', '==', listingId), limit(25))
        getDocs(q)
            .then(res => {
              let orders = []
              if(!res.empty) {
                res.forEach(doc => {
                  orders.push(doc.data())
                })
                this.baskets = orders
                //console.log(orders)
                // this.lastDoc = orders[res.docs.length-1]
              } else {
                this.basketLoadingStatus = 'No baskets found'
              }
            })
        .then(() => {
          this.$store.dispatch('setLoading', false)
        })
      },
      createOrder() {
        this.newSaleDialog = false
        let order = {
          lineItems: [{
            ...this.itemFound,
            qty: 1
          }],
          locations: [],
          created: Date.now(),
          total: 0,
          discount: 0,
          id: uuidv1(),
          fulfillmentInfo: {},
          payments: []
        }
        if (this.itemFound.listing) {
          order.refListing = this.itemFound.listing
        }
        //console.log(order)
        let db = this.$store.state.db
        let salesRef = doc(db, 'users', this.user.uid, 'orders', order.id)
        let dispatchRef = doc(db, 'users', this.user.uid, 'dispatch', order.id)
        let fulfillmentRef = doc(db, 'users', this.user.uid, 'fulfillment', order.id)
        setDoc(salesRef, order)
          .then(() => {
            return setDoc(dispatchRef, {
              orderData: order,
              contractors: [],
              status: 'warning'
            })
          })
          .then(() => {
            return setDoc(fulfillmentRef, {
              orderData: order,
              ETA: "",
              lastActive: {},
              status: 'warning'
            })
          })
          .then(() => {
            //console.log(order)
            this.$router.push('/booking/' + order.id)
            this.newSaleDialog = false
          })

          .catch(err => [
            this.$store.dispatch('setError', err)
          ])
        //this.$router.push('/sale/' + order.id)
      },
      itemSelected (item) {
        this.itemFound = item
        //console.log(this.itemFound)
      }
    }

  }
</script>
